namespace $ {

	export class $shm_listener extends $mol_dom_listener {

		constructor(
			event: string,
			handler: ( event: any )=> any,
			node = $mol_dom_context.document,
			config: boolean | { passive: boolean } = { passive: true },
		) {
			super( node, event, handler, config )
		}

	}

}
